import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LaptopMacIcon(props: IconProps) {
    return <Icon {...props} iconKey={"laptop_mac"}/>
}
